import { cn } from "../../lib/utils";

// Skeleton loader component with premium GOATGYM styling
const Skeleton = ({ className, ...props }) => {
  return (
    <div
      className={cn(
        "animate-pulse rounded-lg bg-gradient-to-r from-[#1A1A1A] via-[#2A2A2A] to-[#1A1A1A] bg-[length:200%_100%]",
        className
      )}
      style={{ animationDuration: '1.5s' }}
      {...props}
    />
  );
};

// Recipe card skeleton
export const RecipeCardSkeleton = () => (
  <div className="bg-[#1A1A1A] rounded-xl overflow-hidden border border-[#2A2A2A]">
    <Skeleton className="h-32 rounded-none" />
    <div className="p-3 space-y-2">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-3 w-1/2" />
      <div className="flex gap-2 pt-1">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-12" />
      </div>
    </div>
  </div>
);

// Profile card skeleton
export const ProfileCardSkeleton = () => (
  <div className="bg-[#1A1A1A] rounded-2xl p-5 border border-[#2A2A2A]">
    <div className="flex items-start gap-4">
      <Skeleton className="w-16 h-16 rounded-2xl" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-5 w-24" />
        <div className="flex gap-2">
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-5 w-20 rounded-full" />
        </div>
        <Skeleton className="h-3 w-32" />
      </div>
    </div>
  </div>
);

// Stat card skeleton
export const StatCardSkeleton = () => (
  <div className="bg-[#1A1A1A] rounded-xl p-4 border border-[#2A2A2A]">
    <div className="flex items-center gap-2 mb-2">
      <Skeleton className="w-4 h-4 rounded" />
      <Skeleton className="h-3 w-16" />
    </div>
    <Skeleton className="h-6 w-12" />
  </div>
);

// Workout card skeleton
export const WorkoutCardSkeleton = () => (
  <div className="bg-[#1A1A1A] rounded-xl p-4 border border-[#2A2A2A]">
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-3">
        <Skeleton className="w-12 h-12 rounded-xl" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-16" />
        </div>
      </div>
      <Skeleton className="w-8 h-8 rounded-lg" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-3/4" />
    </div>
  </div>
);

// List item skeleton
export const ListItemSkeleton = () => (
  <div className="flex items-center gap-3 p-3 bg-[#1A1A1A] rounded-lg border border-[#2A2A2A]">
    <Skeleton className="w-10 h-10 rounded-lg" />
    <div className="flex-1 space-y-2">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-3 w-20" />
    </div>
    <Skeleton className="w-4 h-4 rounded" />
  </div>
);

// Full page loading skeleton
export const PageSkeleton = () => (
  <div className="p-4 space-y-4">
    <Skeleton className="h-8 w-48 mb-6" />
    <div className="grid grid-cols-2 gap-3">
      {[1, 2, 3, 4].map(i => (
        <StatCardSkeleton key={i} />
      ))}
    </div>
    <div className="space-y-3 mt-4">
      {[1, 2, 3].map(i => (
        <ListItemSkeleton key={i} />
      ))}
    </div>
  </div>
);

// Recipes grid skeleton
export const RecipesGridSkeleton = () => (
  <div className="grid gap-4">
    {[1, 2, 3, 4, 5, 6].map(i => (
      <RecipeCardSkeleton key={i} />
    ))}
  </div>
);

export default Skeleton;
